/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'extension.charts.aggregateData': 'Agregar dados',
  'extension.charts.aggregateDataDescription':
    'Combine valores em um ponto de dados único quando linhas múltiplas tiverem o mesmo valor.',
  'extension.charts.category': 'Categoria',
  'extension.charts.customizeTab': 'Personalizar',
  'extension.charts.dataMissing.details': 'Não foi possível encontrar a tabela de origem deste gráfico na página.',
  'extension.charts.dataMissing.title': 'Não há dados disponíveis para exibição',
  'extension.charts.dataTab': 'Dados',
  'extension.charts.defaultColumnName': 'Coluna {0}',
  'extension.charts.defaultTitle': 'Gráfico sem título',
  'extension.charts.defaultYLabel': 'Eixo sem título',
  'extension.charts.extensionTitle': 'Gráfico',
  'extension.charts.height': 'Altura da área do gráfico',
  'extension.charts.height.large': 'Mais alto',
  'extension.charts.height.medium': 'Padrão',
  'extension.charts.height.small': 'Mais baixo',
  'extension.charts.horizontal.orientation.label': 'Horizontal',
  'extension.charts.insert.tooltip': 'Inserir gráfico',
  'extension.charts.legend': 'Legenda',
  'extension.charts.legend.auto': 'Automático',
  'extension.charts.legend.bottom': 'Parte inferior',
  'extension.charts.legend.left': 'Esquerda',
  'extension.charts.legend.position': 'Posição de legenda',
  'extension.charts.legend.right': 'Direita',
  'extension.charts.legend.show': 'Mostrar legenda',
  'extension.charts.legend.top': 'Parte superior',
  'extension.charts.options.label': 'Opções do gráfico',
  'extension.charts.options.tooltip': 'Alterar as opções do gráfico',
  'extension.charts.orientation.label': 'Orientação',
  'extension.charts.seriesNames': 'Série de dados',
  'extension.charts.showPoints': 'Mostrar pontos de dados',
  'extension.charts.smoothLines': 'Linhas suaves',
  'extension.charts.style': 'Estilo',
  'extension.charts.title': 'Título',
  'extension.charts.type.bar': 'Barra',
  'extension.charts.type.fieldDescription': 'Tipo de gráfico',
  'extension.charts.type.line': 'Linha',
  'extension.charts.type.pie': 'Em pizza',
  'extension.charts.userTitle': 'Título',
  'extension.charts.vertical.orientation.label': 'Vertical',
  'extension.charts.xAxis': 'Eixo x',
  'extension.charts.xLabel': 'Categoria do eixo X',
  'extension.charts.yLabel': 'Rótulo de eixo Y',
};
